import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ServiceRfqTokenAuthService {
  private readonly tokenKey = 'serviceRfqAccessToken';
  private readonly serviceRfqIdKey = 'serviceRfqId';
  private readonly supplierIdKey = 'serviceRfqSupplierId';

  set(
    serviceRfqAccessToken: string,
    serviceRfqId: string | number,
    supplierId?: string | number | null
  ): void {
    if (serviceRfqAccessToken) sessionStorage.setItem(this.tokenKey, serviceRfqAccessToken);
    if (serviceRfqId !== undefined && serviceRfqId !== null) {
      sessionStorage.setItem(this.serviceRfqIdKey, String(serviceRfqId));
    }
    if (supplierId !== undefined && supplierId !== null) {
      sessionStorage.setItem(this.supplierIdKey, String(supplierId));
    }
  }

  clear(): void {
    sessionStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.serviceRfqIdKey);
    sessionStorage.removeItem(this.supplierIdKey);
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.tokenKey);
  }

  getServiceRfqId(): string | null {
    return sessionStorage.getItem(this.serviceRfqIdKey);
  }

  getSupplierId(): string | null {
    return sessionStorage.getItem(this.supplierIdKey);
  }

  buildAuthHeaders(): { headers: HttpHeaders } | {} {
    const token = this.getToken();
    if (!token) return {};
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    return { headers };
  }
}
